import { APIError, FrontNotificationType } from '@/data'
import { useEMTDispatch } from '@/store'
import { useTranslation } from 'next-i18next'
import { addNotification, NotificationContent } from './NotificationsServiceHelper'
import { ObjectKeys } from '@/utils'

export const useNotificationError = () => {
  const dispatch = useEMTDispatch()
  const { t } = useTranslation('common')

  /**
   * Display global error is exists, and get all fields in error
   * @param param0
   * @returns Record<fieldKey: string, errorMessage: string>
   */
  const addNotificationError = <T>({
    error,
    ...params
  }: Partial<NotificationContent<T>> & { error: Error | null }): Record<string, string> => {
    console.log(error)
    const title = params.title || t('error.genericTitle')
    let message: string

    let fields: Record<string, string> = {}

    if (
      error instanceof APIError &&
      (error.errorManagerMessage?.length || ObjectKeys(error.errorManagerFields)?.length)
    ) {
      console.log('Using error message from APIError')
      message = error.errorManagerMessage as string
      fields = error.errorManagerFields
    } else if (params.message) {
      console.log('Using specific error message from params')
      message = params.message
    } else {
      console.log('No specific error message, using generic')
      message = t('error.genericMessage')
    }

    if (title && message) {
      console.log('Adding notification with title and message')
      addNotification(dispatch)({
        ...params,
        type: FrontNotificationType.ERROR,
        title,
        message,
      })
    }

    return fields
  }

  return [addNotificationError]
}

export const useNotifications = () => {
  const dispatch = useEMTDispatch()
  const { t } = useTranslation('common')

  /**
   * Display global error is exists, and get all fields in error
   * @param param0
   * @returns Record<fieldKey: string, errorMessage: string>
   */
  const addNotificationError = <T>({
    error,
    ...params
  }: Partial<NotificationContent<T>> & { error: Error }): Record<string, string> => {
    const title = params.title || t('error.genericTitle')
    let message: string | undefined | null

    let fields: Record<string, string> = {}

    if (error instanceof APIError && (error.errorManagerMessage || error.errorManagerFields)) {
      message = error.errorManagerMessage
      fields = error.errorManagerFields
    }

    if (!message?.length) {
      message = t('error.genericMessage')
    }

    if (title && message) {
      addNotification(dispatch)({
        ...params,
        type: FrontNotificationType.ERROR,
        title,
        message,
      })
    }

    return fields
  }

  const addNotificationSuccess = <T>({ ...params }: Partial<NotificationContent<T>>) => {
    const title = params.title || t('success.genericTitle')
    const message = params.message || undefined

    if (title && message) {
      addNotification(dispatch)({
        ...params,
        type: FrontNotificationType.SUCCESS,
        title,
        message,
      })
    }
  }

  return [addNotificationError, addNotificationSuccess] as const
}
